// Mobile web: a card heading that must stay on one line (owner, 09.10.2026).
// Measured in Chrome on the web bundle: the auth card leaves `width - 90` px
// for the heading (360→270, 375→285, 390→300, 412→322). Each phrase has its
// own width per 1 px of font size (Nunito Sans 700), passed in by the screen.
// Largest size that fits with a 2 px margin, never above the uiH1 token (40).
export const narrowFormTitleSize = (width: number, pxPerFontPx: number): number =>
  Math.min(40, Math.max(26, Math.floor((width - 92) / pxPerFontPx)));
